import { ChangeDetectionStrategy, Component, EventEmitter, Inject, LOCALE_ID, OnInit, Output } from '@angular/core';
import { MobileService, SideNaveDataTypes } from '@klickdata/core/mobile';

@Component({
    selector: 'app-guest-mode-header',
    templateUrl: './guest-mode-header.component.html',
    styleUrls: ['./guest-mode-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuestModeHeaderComponent implements OnInit {
    @Output() onOpenSearch: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onLogin: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor(@Inject(LOCALE_ID) protected localeId: string, protected mobile: MobileService) {}

    ngOnInit(): void {}
    public openLink() {
        this.localeId === 'en'
            ? window.open('https://klickdata.se/english', '_blank')
            : window.open('https://klickdata.se/produkter-tj%C3%A4nster/lms', '_blank');
    }
}
